import script from "./AddTerminalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTerminalComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddTerminalComponent.vue?vue&type=style&index=0&id=2e339312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e339312"]])

export default __exports__